import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    creditor: Yup.number()
      .nullable()
      .required("US.COLLECTION.VALIDATIONS:INVALID.CREDITOR_IS_REQUIRED"),
    fileType: Yup.number()
      .nullable()
      .required("US.COLLECTION.VALIDATIONS:INVALID.FILE_TYPE_IS_REQUIRED"),
  });
};
